// Add your custom JS here.


jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 50) {
        jQuery("header.header-site").addClass("scrolled");
    } else {
        jQuery("header.header-site").removeClass("scrolled");
    }
});

jQuery(document).ready(function ($) { });

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)"
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

// AOS (Animate On Scroll) refresh on AJAX content load
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS === "undefined") return;
    jQuery(document).on("sf:ajaxfinish", function () {
        AOS.refreshHard();
    });

    var target = document.querySelector("#block-search-and-filter");
    if (target) {
        var resizeObserver = new ResizeObserver(function () {
            AOS.refreshHard();
        });
        resizeObserver.observe(target);
    }
});

//  Smooth scroll for hash links
document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth < 992;
    const offset = isMobile ? 180 : 230;

    function scrollToHash(hash) {
        const el = document.querySelector(hash);
        if (el) {
            setTimeout(() => {
                window.scrollTo({
                    top:
                        el.getBoundingClientRect().top +
                        window.pageYOffset -
                        offset,
                    behavior: "smooth",
                });
            }, 50);
        }
    }

    if (window.location.hash) {
        scrollToHash(window.location.hash);
    }

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener("click", function (e) {
            const hash = this.getAttribute("href");
            if (hash.length > 1) {
                e.preventDefault();
                history.pushState(null, null, hash);
                scrollToHash(hash);
            }
        });
    });
});



// Header Buttons in Mega Menu Mobile
document.addEventListener("DOMContentLoaded", function () {
    const megaMenu = document.querySelector("#mega-menu-primary");
    const headerButtons = document.querySelector(".header-buttons");

    if (!headerButtons || !megaMenu) return;

    const originalParent = headerButtons.parentNode;

    const liButtons = document.createElement("li");
    liButtons.className = "mega-menu-item mega-menu-item-type-custom mega-align-bottom-left mega-menu-flyout menu-item-header-buttons";

    let isInMegaMenu = false;

    function moveButtonsToMenu() {
        if (window.innerWidth <= 1200 && !isInMegaMenu) {
            liButtons.appendChild(headerButtons);
            megaMenu.appendChild(liButtons);
            isInMegaMenu = true;
        } else if (window.innerWidth > 1200 && isInMegaMenu) {
            originalParent.appendChild(headerButtons);
            if (liButtons.parentNode) liButtons.parentNode.removeChild(liButtons);
            isInMegaMenu = false;
        }
    }

    moveButtonsToMenu();
    window.addEventListener("resize", moveButtonsToMenu);
});


// Lenis Smooth Scroll
document.addEventListener("DOMContentLoaded", function () {
    // Initialize Lenis
    new Lenis({
        autoRaf: true,
    });

});

// Grid Cards Info — Mobile Swiper
(function () {
    function initGridCardsSwiper() {
        document.querySelectorAll('.cards-swiper').forEach(function (el) {
            var grid = el.closest('.cards-grid');
            if (window.innerWidth < 768) {
                if (!el._swiper) {
                    el._swiper = new Swiper(el, {
                        slidesPerView: 1,
                        centeredSlides: true,
                        spaceBetween: 16,
                        loop: true,
                        navigation: {
                            nextEl: grid.querySelector('.swiper-custom-next'),
                            prevEl: grid.querySelector('.swiper-custom-prev'),
                        },
                    });
                }
            } else {
                if (el._swiper) {
                    el._swiper.destroy(true, true);
                    el._swiper = null;
                }
            }
        });
    }

    document.addEventListener('DOMContentLoaded', initGridCardsSwiper);
    window.addEventListener('resize', initGridCardsSwiper);
})();

// Mobile Mega Menu — accordion submenus
document.addEventListener('DOMContentLoaded', function () {
    const megaMenuPrimary = document.querySelector('#mega-menu-primary');
    const megaMenuToggle = document.querySelector('.mega-menu-toggle');

    if (!megaMenuPrimary) return;

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            const target = mutation.target;

            // A top-level li just gained mega-toggle-on — collapse all siblings
            if (
                target.tagName === 'LI' &&
                target.parentElement === megaMenuPrimary &&
                target.classList.contains('mega-toggle-on')
            ) {
                megaMenuPrimary.querySelectorAll(':scope > li.mega-toggle-on').forEach(function (li) {
                    if (li !== target) li.classList.remove('mega-toggle-on');
                });
            }

            // Main toggle closed — collapse every open submenu
            if (target === megaMenuToggle && !target.classList.contains('mega-menu-open')) {
                megaMenuPrimary.querySelectorAll('li.mega-toggle-on').forEach(function (li) {
                    li.classList.remove('mega-toggle-on');
                });
            }
        });
    });

    observer.observe(megaMenuPrimary, { subtree: true, attributes: true, attributeFilter: ['class'] });

    if (megaMenuToggle) {
        observer.observe(megaMenuToggle, { attributes: true, attributeFilter: ['class'] });
    }
});

// Video Play Button Overlay
(function () {
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('figure.wp-block-video').forEach(function (figure) {
            var video = figure.querySelector('video');
            if (!video) return;

            var playBtn = document.createElement('button');
            playBtn.className = 'video-play-btn';
            playBtn.setAttribute('aria-label', 'Play video');
            figure.appendChild(playBtn);

            playBtn.addEventListener('click', function () {
                video.play();
            });

            video.addEventListener('play', function () { figure.classList.add('is-playing'); });
            video.addEventListener('pause', function () { figure.classList.remove('is-playing'); });
            video.addEventListener('ended', function () { figure.classList.remove('is-playing'); });
        });
    });
})();
